/* eslint-disable */
import React from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { OPEN_EMS_UI_URL } from '../../utils/openEmsUrls';
import styles from './B2bTariffsTable.module.css';

const FEATURES = [
  { id: 1, key: 'feature1', base: true, pro: true, proPlus: true },
  { id: 2, key: 'feature2', base: true, pro: true, proPlus: true },
  { id: 3, key: 'feature3', base: true, pro: true, proPlus: true },
  { id: 4, key: 'feature4', base: true, pro: true, proPlus: true },
  { id: 15, key: 'feature15', base: true, pro: true, proPlus: true },
  { id: 5, key: 'feature5', base: false, pro: true, proPlus: true },
  { id: 6, key: 'feature6', base: false, pro: true, proPlus: true },
  { id: 7, key: 'feature7', base: false, pro: true, proPlus: true },
  { id: 8, key: 'feature8', base: false, pro: true, proPlus: true },
  { id: 9, key: 'feature9', base: false, pro: true, proPlus: true },
  { id: 11, key: 'feature11', base: false, pro: false, proPlus: true },
  { id: 12, key: 'feature12', base: false, pro: false, proPlus: true },
  { id: 13, key: 'feature13', base: false, pro: false, proPlus: true },
  { id: 16, key: 'feature16', base: false, pro: false, proPlus: true },
  { id: 18, key: 'feature18', base: false, pro: false, proPlus: true },
  { id: 14, key: 'feature14', base: true, pro: true, proPlus: true },
  { id: 20, key: 'feature20', base: false, pro: false, proPlus: true },
  { id: 19, key: 'feature19', base: false, pro: false, proPlus: true, ems: true },
];

function VyriyEmsLink({ t, className }) {
  return (
    <a
      href={OPEN_EMS_UI_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label={t('b2bTariffs.feature19')}
    >
      <span className={styles.tariffHeaderEmsLabel}>{t('b2bTariffs.tariffProPlusEmsLabel')}</span>
      <span className={styles.tariffHeaderRateBadge}>{t('b2bTariffs.tariffProPlusEmsName')}</span>
    </a>
  );
}

export default function B2bTariffsTable({ hideTitle = false }) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.card}${hideTitle ? ` ${styles.cardCompact}` : ''}`}>
      {hideTitle ? null : (
        <>
          <h2 className={styles.title}>{t('b2bTariffs.title')}</h2>
          <div className={styles.divider} />
        </>
      )}
      <div className={styles.tableWrap}>
        <Table bordered responsive className={styles.table}>
          <thead>
            <tr>
              <th className={styles.tariffHeaderCell}>
                <div className={styles.tariffHeaderInner}>{t('b2bTariffs.features')}</div>
              </th>
              <th className={styles.tariffHeaderCell}>
                <div className={styles.tariffHeaderInner}>
                  <span className={styles.tariffHeaderName}>{t('b2bTariffs.tariffBaseName')}</span>
                  <span className={styles.tariffHeaderRateBadge}>{t('b2bTariffs.tariffBaseRate')}</span>
                </div>
              </th>
              <th className={styles.tariffHeaderCell}>
                <div className={styles.tariffHeaderInner}>
                  <span className={styles.tariffHeaderName}>{t('b2bTariffs.tariffProName')}</span>
                  <span className={styles.tariffHeaderRateBadge}>{t('b2bTariffs.tariffProRate')}</span>
                </div>
              </th>
              <th className={styles.tariffHeaderCell}>
                <div className={styles.tariffHeaderInner}>
                  <span className={styles.tariffHeaderName}>{t('b2bTariffs.tariffProPlusName')}</span>
                  <span className={styles.tariffHeaderRateBadge}>{t('b2bTariffs.tariffProPlusRate')}</span>
                  <VyriyEmsLink t={t} className={styles.tariffHeaderEmsBlock} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {FEATURES.map((feature, index) => (
              <tr key={feature.id}>
                <td>
                  {feature.ems ? (
                    <VyriyEmsLink t={t} className={styles.featureEmsLink} />
                  ) : (
                    t(`b2bTariffs.${feature.key}`)
                  )}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span className={`${styles.cellPlusMinus} ${feature.base ? styles.plus : styles.minus}`}>
                    {feature.base ? '+' : '-'}
                  </span>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span className={`${styles.cellPlusMinus} ${feature.pro ? styles.plus : styles.minus}`}>
                    {feature.pro ? '+' : '-'}
                  </span>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span className={`${styles.cellPlusMinus} ${feature.proPlus ? styles.plus : styles.minus}`}>
                    {feature.proPlus ? '+' : '-'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
